module.exports = __webpack_public_path__ + "img/validator2.ba2121cc.jpg";